import { resolveWidget } from './resolveWidget'
import { createDefaultDashboardTabs } from './tabCatalogue'
import type { DashboardTabSettings, StatusDashboardSettings } from './types'

export const resolveDashboardTabs = (
    settings: StatusDashboardSettings | undefined,
    airport: string | undefined,
): DashboardTabSettings[] => {
    if (!airport) {
        return []
    }
    return (settings?.tabs ?? createDefaultDashboardTabs([airport]))
        .filter(tab => tab.airports.includes(airport))
        .map(tab => ({
            ...tab,
            widgets: tab.widgets.filter(widget => resolveWidget(settings, widget, airport).enabled),
        }))
        .filter(tab => tab.widgets.length > 0)
}
